

const SvgSetup = ({ children }: { children: React.ReactNode }) => <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
>
    {children}
</svg>

export const svgIcons = {
    checkmark: () => <SvgSetup>
        <polyline points="20 6 9 17 4 12" />
    </SvgSetup>,

    clipboard: () => <SvgSetup>
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </SvgSetup>,

    qrCode: () => <SvgSetup>
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
    </SvgSetup>,

    xIcon: () => <SvgSetup>
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </SvgSetup>,
}